import { render, staticRenderFns } from "./ChatDrawer.vue?vue&type=template&id=3d7cea20&scoped=true&"
import script from "./ChatDrawer.vue?vue&type=script&lang=js&"
export * from "./ChatDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ChatDrawer.vue?vue&type=style&index=0&id=3d7cea20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7cea20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
